import React, { useEffect, useRef, useState, useCallback } from "react";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import InactiveDevice from "../Components/Modal/InactiveDevice";
import "../../Style/datatables_custom.css";
import { initDatatable } from "../../JavaScript/Datatables";
import "datatables.net-buttons";
import JSZip from "jszip";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-responsive";
import styled from "styled-components";
import {
  changeApistate,
  changeCreateModalStata,
  changeModalState,
  disableFilterCondition,
  disableSortCondition,
  setLoader,
} from "../../Database/Action/ConstantAction";
import {
  getNewDeviceList,
  deleteNewDevice,
  getUnregisteredDevices,
  deleteUnregisteredDevice,
} from "../../Database/Action/DashboardAction";
import NoData from "../Components/NoData";
import {
  filterCondition,
  sortinCondition,
} from "../Constant/FilterConditionList";

// Import the separate components
import CreateNewCharger from "../Components/Modal/NewCreateCharger";
import EditNewCharger from "../Components/Modal/EditNewCharger";

const NewChargerController = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const createRef = useRef(null);

  // Redux state
  const newDeviceList = useSelector(
    (state) => state.DashboardReducer.newDeviceList
  );
  const mainNewDeviceList = useSelector(
    (state) => state.DashboardReducer.mainNewDeviceList
  );
  const unregisteredDevices = useSelector(
    (state) => state.DashboardReducer.unregisteredDevices || []
  );
  const apistate = useSelector((state) => state.ConstantReducer.apistate);

  // Modal states
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isUnregisteredModalOpen, setIsUnregisteredModalOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedUnregisteredDevice, setSelectedUnregisteredDevice] =
    useState(null);
  const [isInactiveModalOpen, setIsInactiveModalOpen] = useState(false);
  const [unregisteredSearchTerm, setUnregisteredSearchTerm] = useState("");
  const [filteredUnregisteredDevices, setFilteredUnregisteredDevices] =
    useState([]);

  // Filter and sort states
  const columnId = useSelector((state) => state.DashboardReducer.columnId);
  const conditionId = useSelector(
    (state) => state.DashboardReducer.conditionId
  );
  const sortColumnId = useSelector(
    (state) => state.DashboardReducer.sortColumnId
  );
  const sortConditionId = useSelector(
    (state) => state.DashboardReducer.sortConditionId
  );

  // Component states
  const [devices, setDevices] = useState([]);
  const dataTableRef = useRef(null);
  const mountedRef = useRef(true);
  const modalRef = useRef(null);

  // ✅ This ref holds the div where we render the table OUTSIDE React
  const tableContainerDivRef = useRef(null);

  // ✅ Keep a ref to devices so jQuery handlers always see latest data
  const devicesRef = useRef([]);
  useEffect(() => {
    devicesRef.current = devices;
  }, [devices]);

  // Fetch unregistered devices on component mount
  useEffect(() => {
    dispatch(getUnregisteredDevices({ navigate }));
  }, [dispatch, navigate]);

  // Handle Edit
  const handleEdit = useCallback((device) => {
    setSelectedDevice(device);
    setIsEditModalOpen(true);
  }, []);

  // Handle Create
  const handleCreate = useCallback(() => {
    setSelectedUnregisteredDevice(null);
    setIsCreateModalOpen(true);
  }, []);

  // Handle Register from unregistered devices modal
  const handleRegisterUnregistered = useCallback((device) => {
    setSelectedUnregisteredDevice(device);
    setIsUnregisteredModalOpen(false);
    setIsCreateModalOpen(true);
  }, []);

  // Filter unregistered devices based on search
  useEffect(() => {
    if (unregisteredDevices && unregisteredDevices.length > 0) {
      const filtered = unregisteredDevices.filter((device) => {
        const searchLower = unregisteredSearchTerm.toLowerCase();
        return (
          device.UID?.toLowerCase().includes(searchLower) ||
          device.Location?.toLowerCase().includes(searchLower)
        );
      });
      setFilteredUnregisteredDevices(filtered);
    } else {
      setFilteredUnregisteredDevices([]);
    }
  }, [unregisteredSearchTerm, unregisteredDevices]);

  const handleDeleteUnregistered = useCallback(
    (uid) => {
      if (
        !window.confirm(
          "Are you sure you want to delete this unregistered device?"
        )
      )
        return;
      dispatch(deleteUnregisteredDevice(uid, navigate));
    },
    [dispatch, navigate]
  );

  const handleUnregisteredSearch = useCallback((e) => {
    setUnregisteredSearchTerm(e.target.value);
  }, []);

  // Handle Delete
  const handleDelete = useCallback(
    (deviceId) => {
      if (window.confirm("Are you sure you want to delete this device?")) {
        dispatch(deleteNewDevice(deviceId, navigate));
      }
    },
    [dispatch, navigate]
  );

  // Handle modal success callbacks
  const handleOperationSuccess = useCallback(() => {
    dispatch(getNewDeviceList({ navigate: navigate }));
    dispatch(getUnregisteredDevices({ navigate }));
  }, [dispatch, navigate]);

  // Handle closing modals
  const handleCloseCreateModal = useCallback(() => {
    setIsCreateModalOpen(false);
    setSelectedUnregisteredDevice(null);
  }, []);

  const handleCloseEditModal = useCallback(() => {
    setIsEditModalOpen(false);
    setSelectedDevice(null);
  }, []);

  const handleCloseUnregisteredModal = useCallback(() => {
    setIsUnregisteredModalOpen(false);
  }, []);

  const handleOpenUnregisteredModal = useCallback(() => {
    setIsUnregisteredModalOpen(true);
  }, []);

  // Click outside to close modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleCloseUnregisteredModal();
      }
    };

    if (isUnregisteredModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isUnregisteredModalOpen, handleCloseUnregisteredModal]);

  const openModal = (title, column, data) => {
    dispatch(
      changeModalState({
        openState: true,
        content: title,
        dataColumn: column,
        data: data,
        screenName: "NewChargerController",
      })
    );
  };

  const getConditionName = Array.isArray(filterCondition)
    ? filterCondition.filter((item) => item.id === conditionId)
    : [];

  const getSortConditionName = Array.isArray(sortinCondition)
    ? sortinCondition.filter((item) => item.id === sortConditionId)
    : [];

  // Handle opening inactive devices modal
  const handleOpenInactiveModal = useCallback(() => {
    setIsInactiveModalOpen(true);
  }, []);

  // Handle closing inactive devices modal
  const handleCloseInactiveModal = useCallback(() => {
    setIsInactiveModalOpen(false);
  }, []);

  useEffect(() => {
    dispatch(changeApistate());
  }, []);

  useEffect(() => {
    dispatch(getNewDeviceList({ navigate: navigate }));
  }, [dispatch, apistate]);

  useEffect(() => {
    setDevices(newDeviceList);
  }, [newDeviceList, apistate]);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  // ============================================================
  // ✅ FIXED: DataTable rendered OUTSIDE React's virtual DOM
  // React only manages an empty div via tableContainerDivRef.
  // The table + rows are built with innerHTML so DataTables
  // can freely move/sort/paginate <tr> nodes without conflicting
  // with React's reconciler. No more removeChild/insertBefore crashes.
  // ============================================================
  useEffect(() => {
    let timeoutId = null;

    const renderTable = () => {
      if (!mountedRef.current || !tableContainerDivRef.current) return;

      // 1. Destroy existing DataTable if any
      try {
        if ($.fn.DataTable.isDataTable("#example-datatables")) {
          $("#example-datatables").DataTable().destroy();
        }
      } catch (e) {}

      // 2. Build table HTML manually (outside React's control)
      const escapeHtml = (str) => {
        if (!str) return "";
        return String(str)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      };

      let rowsHtml = "";
      if (devices.length === 0) {
        rowsHtml = `<tr><td colspan="19" style="text-align:center;padding:40px;color:#999;">No data available</td></tr>`;
      } else {
        devices.forEach((item, index) => {
          const isActive = item?.status === "active";
          const donorName =
            item?.donor?.DonarOrganisation ||
            item?.DonarName ||
            item?.donor?.name ||
            item?.donor_name ||
            "NULL";
          const rewName =
            item?.rew?.rew_name ||
            item?.REW?.rew_name ||
            item?.rew_name ||
            "N/A";
          const deviceJson = encodeURIComponent(JSON.stringify(item));
          const id = item?.ID || item?.id || index;

          const formatDate = (dateString) => {
            if (!dateString) return "N/A";
            return new Date(dateString).toLocaleString();
          };

          rowsHtml += `<tr class="${!isActive ? "inactive-row" : ""}">
            <td class="text-dark" style="font-size:14px;cursor:pointer;text-decoration:underline;" data-uid="${escapeHtml(item?.UID)}" data-navigate="true">
              ${item?.Location ? `<div style="color:#d4af37;font-weight:300;font-size:14px;">${escapeHtml(item.Location)}</div>` : ""}
              <div style="font-weight:300;font-size:14px;">${escapeHtml(item?.UID)}</div>
            </td>
            <td>
              <span class="status-badge ${isActive ? "status-active" : "status-inactive"}">
                ${isActive ? "Active" : "Inactive"}
              </span>
              ${!isActive && item?.RecordTime ? `<div class="last-seen-small">Last: ${formatDate(item.RecordTime)}</div>` : ""}
            </td>
            <td>
              <div style="display:flex;gap:4px;">
                <button class="delete-btn" data-id="${id}" style="background:red;color:white;border:none;padding:8px 12px;border-radius:4px;cursor:pointer;">
                  <i class="fa-solid fa-trash"></i>
                </button>
                <button class="edit-btn" data-device="${deviceJson}" style="background:#0096c7;color:white;border:none;padding:8px 12px;border-radius:4px;cursor:pointer;">
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
              </div>
            </td>
            <td>${escapeHtml(item?.NameOfBeneficiary) || "NULL"}</td>
            <td>${escapeHtml(item?.BeneficiaryPno) || "NULL"}</td>
            <td>${escapeHtml(item?.InstallationDate) || "NULL"}</td>
            <td>${escapeHtml(item?.PanchayatSamiti) || "NULL"}</td>
            <td>${escapeHtml(donorName)}</td>
            <td>${escapeHtml(item?.VillageName) || "NULL"}</td>
            <td>${escapeHtml(rewName)}</td>
            <td>${escapeHtml(item?.CLocation) || "NULL"}</td>
            <td>${escapeHtml(item?.Block) || "NULL"}</td>
            <td>${escapeHtml(item?.District) || "NULL"}</td>
            <td>${escapeHtml(item?.State) || "NULL"}</td>
            <td>${escapeHtml(item?.Country) || "NULL"}</td>
            <td>${escapeHtml(item?.GCName) || "NULL"}</td>
            <td>${escapeHtml(item?.GCPhoneNumber) || "NULL"}</td>
            <td>${escapeHtml(item?.SolarEngineerName) || "NULL"}</td>
            <td>${escapeHtml(item?.SolarEngineerPno) || "NULL"}</td>
          </tr>`;
        });
      }

      // 3. Set innerHTML — React never touches this
      tableContainerDivRef.current.innerHTML = `
        <table id="example-datatables" class="table text-fade table-bordered table-hover margin-top-10 w-p100" style="width:100%">
          <thead>
            <tr class="text-dark">
              <th>UIDLocation<br/>UID</th>
              <th>Status</th>
              <th>Action</th>
              <th>Beneficiary Name</th>
              <th>Beneficiary Phone</th>
              <th>Installation Date</th>
              <th>Panchayat Samiti</th>
              <th>Donor Name</th>
              <th>Village</th>
              <th>REW Name</th>
              <th>Location</th>
              <th>Block</th>
              <th>District</th>
              <th>State</th>
              <th>Country</th>
              <th>GC Name</th>
              <th>GC Phone</th>
              <th>Solar Engineer</th>
              <th>Engineer Phone</th>
            </tr>
          </thead>
          <tbody>${rowsHtml}</tbody>
        </table>`;

      // 4. Init DataTable if we have data
      if (devices.length > 0) {
        window.JSZip = JSZip;
        setTimeout(() => {
          if (!mountedRef.current) return;
          try {
            dataTableRef.current = initDatatable();

            // Edit button handler
            $("#example-datatables")
              .off("click.edit")
              .on("click.edit", ".edit-btn", function (e) {
                e.stopPropagation();
                e.preventDefault();
                try {
                  const rawData = $(this).attr("data-device");
                  if (rawData) {
                    handleEdit(JSON.parse(decodeURIComponent(rawData)));
                  }
                } catch (err) {
                  console.error("Edit error:", err);
                }
              });

            // Delete button handler
            $("#example-datatables")
              .off("click.delete")
              .on("click.delete", ".delete-btn", function (e) {
                e.stopPropagation();
                e.preventDefault();
                const id = $(this).data("id");
                if (id) {
                  handleDelete(id);
                }
              });

            // Navigate to graph handler
            $("#example-datatables")
              .off("click.navigate")
              .on(
                "click.navigate",
                "[data-navigate='true']",
                function (e) {
                  e.stopPropagation();
                  const uid = $(this).data("uid");
                  if (uid) {
                    const device = devicesRef.current.find(
                      (d) => d.UID === uid
                    );
                    navigate("/show_graph", {
                      state: { uid, deviceData: device },
                    });
                  }
                }
              );
          } catch (error) {
            console.error("DataTable init error:", error);
          }
        }, 100);
      }
    };

    timeoutId = setTimeout(renderTable, 200);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      try {
        if ($.fn.DataTable.isDataTable("#example-datatables")) {
          $("#example-datatables").DataTable().destroy();
        }
      } catch (e) {}
      dataTableRef.current = null;
    };
  }, [devices, handleEdit, handleDelete, navigate]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString();
  };

  return (
    <Wrapper>
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="row">
              <div className="col-12">
                <div className="box">
                  <div className="row">
                    <div className="box-header with-border d-flex justify-content-between align-items-center">
                      {/* Left Section */}
                      <div className="d-flex align-items-center gap-3">
                        <h4 className="box-title mb-0">
                          Charge Controller Devices
                        </h4>

                        <div className="d-flex gap-2">
                          {/* Unregistered Devices Alert */}
                          {unregisteredDevices?.length > 0 && (
                            <div
                              className="unregistered-alert"
                              onClick={handleOpenUnregisteredModal}
                            >
                              <i className="fa-solid fa-exclamation-circle"></i>
                              <span>
                                {unregisteredDevices.length} Unregistered Device
                                {unregisteredDevices.length > 1 ? "s" : ""}{" "}
                                Waiting for Registration
                              </span>
                            </div>
                          )}

                          {/* Inactive Devices Button */}
                          <div
                            className="inactive-alert"
                            onClick={handleOpenInactiveModal}
                          >
                            <i className="fa-solid fa-clock"></i>
                            <span>
                              {
                                devices?.filter((d) => d?.status === "inactive")
                                  .length
                              }{" "}
                              Inactive Device List
                              {devices?.filter((d) => d?.status === "inactive")
                                .length !== 1
                                ? "s"
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Right Section */}
                      <button
                        className="filterButton"
                        type="button"
                        onClick={handleCreate}
                      >
                        <i
                          className="fa-solid fa-add"
                          style={{ marginRight: "10px" }}
                        />
                        Create
                      </button>
                    </div>
                  </div>

                  <div className="box-body">
                    {/* ✅ React only manages this empty div.
                        The table is rendered via innerHTML inside the useEffect.
                        DataTables can freely move/sort/paginate rows
                        without conflicting with React's virtual DOM. */}
                    <div className="table-responsive" ref={tableContainerDivRef} />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Unregistered Devices Modal */}
      {isUnregisteredModalOpen && (
        <div className="modal-overlay">
          <div className="modal-container" ref={modalRef}>
            <div className="modal-header">
              <h3>
                <i className="fa-solid fa-exclamation-triangle"></i>
                Unregistered Devices
              </h3>
              <button
                className="close-btn"
                onClick={handleCloseUnregisteredModal}
              >
                <i className="fa-solid fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              <p className="modal-subtitle">
                These devices have sent data but are not registered in the
                system. Click Register to add them.
              </p>

              {/* Search Input */}
              <div className="search-container">
                <div className="search-input-wrapper">
                  <i className="fa-solid fa-search search-icon"></i>
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search by UID or Location..."
                    value={unregisteredSearchTerm}
                    onChange={handleUnregisteredSearch}
                  />
                  {unregisteredSearchTerm && (
                    <button
                      className="clear-search-btn"
                      onClick={() => setUnregisteredSearchTerm("")}
                    >
                      <i className="fa-solid fa-times"></i>
                    </button>
                  )}
                </div>
                <div className="search-info">
                  Showing {filteredUnregisteredDevices.length} of{" "}
                  {unregisteredDevices.length} devices
                </div>
              </div>

              <div className="table-responsive">
                <table className="table unregistered-table">
                  <thead>
                    <tr>
                      <th>UID</th>
                      <th>Location</th>
                      <th>First Seen</th>
                      <th>Last Seen</th>
                      <th>Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUnregisteredDevices.length === 0 ? (
                      <tr>
                        <td colSpan={6} className="text-center">
                          {unregisteredSearchTerm ? (
                            <div className="no-search-results">
                              <i className="fa-solid fa-search"></i>
                              <p>
                                No devices found matching "
                                {unregisteredSearchTerm}"
                              </p>
                              <button
                                className="clear-search-btn-text"
                                onClick={() => setUnregisteredSearchTerm("")}
                              >
                                Clear search
                              </button>
                            </div>
                          ) : (
                            <NoData message="No unregistered devices found" />
                          )}
                        </td>
                      </tr>
                    ) : (
                      filteredUnregisteredDevices.map((item) => (
                        <tr key={item.UID}>
                          <td>
                            <strong>{item.UID}</strong>
                          </td>
                          <td>{item.Location || "N/A"}</td>
                          <td>{formatDate(item.firstSeen)}</td>
                          <td>{formatDate(item.lastSeen)}</td>
                          <td>
                            <span className="count-badge">{item.count}</span>
                          </td>
                          <td>
                            <div style={{ display: "flex", gap: "6px" }}>
                              <button
                                className="register-btn"
                                onClick={() =>
                                  handleRegisterUnregistered(item)
                                }
                              >
                                <i className="fa-solid fa-check"></i>
                                Register
                              </button>
                              <button
                                className="delete-unregistered-btn"
                                onClick={() =>
                                  handleDeleteUnregistered(item.UID)
                                }
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn-secondary"
                onClick={handleCloseUnregisteredModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Render CreateNewCharger Modal */}
      {isCreateModalOpen && (
        <CreateNewCharger
          isOpen={isCreateModalOpen}
          onClose={handleCloseCreateModal}
          onSuccess={handleOperationSuccess}
          deviceData={selectedUnregisteredDevice}
        />
      )}

      {/* Render EditNewCharger Modal */}
      {isEditModalOpen && selectedDevice && (
        <EditNewCharger
          deviceData={selectedDevice}
          isOpen={isEditModalOpen}
          onClose={handleCloseEditModal}
          onSuccess={handleOperationSuccess}
        />
      )}

      {/* Inactive Devices Modal */}
      <InactiveDevice
        isOpen={isInactiveModalOpen}
        onClose={handleCloseInactiveModal}
        onSuccess={handleOperationSuccess}
      />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .tableCheckBox {
    border-color: 1px solid white;
  }
  .filterButton {
    background: ${({ theme }) => theme.colors.themeColor};
    padding: 10px 20px 10px 20px;
    color: white;
    margin: 5px;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover,
    &:active {
      background-color: transparent;
      color: ${({ theme }) => theme.colors.themeColor};
      border: 1px solid ${({ theme }) => theme.colors.themeColor};
      transform: scale(0.96);
    }
  }

  input[type="checkbox"] {
    width: 15px;
    height: 15px;
    opacity: 1 !important;
    margin-right: 12px;
    position: relative !important;
    left: 0px;
  }

  .status-badge {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
  }

  .status-active {
    background-color: #d4edda;
    color: #155724;
  }

  .status-inactive {
    background-color: #f8d7da;
    color: #721c24;
  }

  .last-seen-small {
    font-size: 11px;
    color: #999;
    margin-top: 4px;
  }

  .unregistered-alert {
    background: #cc0000;
    color: #ffcccc;
    padding: 8px 15px;
    border-radius: 20px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    font-size: 14px;

    i {
      font-size: 16px;
    }
  }

  .inactive-alert {
    background: #ffc107;
    color: #856404;
    padding: 8px 15px;
    border-radius: 20px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    font-size: 14px;
    border: 1px solid #ffc107;

    i {
      font-size: 16px;
      color: #856404;
    }

    &:hover {
      background: #e0a800;
      color: #533f03;
      transform: scale(1.02);

      i {
        color: #533f03;
      }
    }
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-container {
    background: #fff;
    border-radius: 8px;
    width: 900px;
    max-width: 95%;
    max-height: 80vh;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  }

  .modal-header {
    padding: 15px 20px;
    background: #6c757d;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      font-size: 18px;
      color: #fff;
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        color: #ffc107;
      }
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #fff;

      &:hover {
        color: #533f03;
      }
    }
  }

  .modal-body {
    padding: 20px;
    overflow-y: auto;
    max-height: calc(80vh - 120px);

    .modal-subtitle {
      color: #666;
      font-size: 14px;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #dee2e6;
    }
  }

  .modal-footer {
    padding: 15px 20px;

    .btn-secondary {
      background-color: #6c757d;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        background-color: #5a6268;
      }
    }
  }

  .unregistered-table {
    width: 100%;
    border-collapse: collapse;

    th {
      color: #666;
      padding: 12px;
      text-align: left;
      font-weight: 600;
      border-bottom: 2px solid #dee2e6;
    }

    td {
      color: #666;
      padding: 10px 12px;
      border-bottom: 1px solid #dee2e6;
    }

    tr:hover {
      background-color: #fff9e6;
    }
  }

  .count-badge {
    background-color: #ffc107;
    color: #000;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: bold;
    display: inline-block;
    min-width: 30px;
    text-align: center;
  }

  .register-btn {
    background: #28a745;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: all 0.3s ease;

    i {
      font-size: 12px;
    }

    &:hover {
      background: #218838;
      transform: scale(0.98);
    }
  }

  .d-flex {
    display: flex;
  }

  .gap-2 {
    gap: 0.5rem;
  }

  .gap-3 {
    gap: 1rem;
  }

  .text-center {
    text-align: center;
    padding: 30px !important;
  }

  .search-container {
    margin-bottom: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
  }

  .search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  .search-icon {
    position: absolute;
    left: 12px;
    color: #999;
    font-size: 14px;
  }

  .search-input {
    width: 100%;
    padding: 10px 35px 10px 35px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }

  .clear-search-btn {
    position: absolute;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
    color: #999;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s ease;

    &:hover {
      color: #666;
    }
  }

  .search-info {
    margin-top: 8px;
    font-size: 12px;
    color: #666;
  }

  .no-search-results {
    text-align: center;
    padding: 40px 20px;

    i {
      font-size: 48px;
      color: #dee2e6;
      margin-bottom: 15px;
    }

    p {
      color: #666;
      margin-bottom: 15px;
      font-size: 14px;
    }
  }

  .clear-search-btn-text {
    background: none;
    border: none;
    color: #007bff;
    cursor: pointer;
    font-size: 13px;
    text-decoration: underline;
    padding: 5px 10px;

    &:hover {
      color: #0056b3;
    }
  }

  .delete-unregistered-btn {
    background: #dc3545;
    color: white;
    border: none;
    padding: 6px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    transition: all 0.3s ease;

    &:hover {
      background: #c82333;
      transform: scale(0.98);
    }
  }
`;

export default NewChargerController;